const PLAN_SOFT_CAP = 4000;
const PLAN_HEAD_CHARS = 3000;
const PLAN_TAIL_CHARS = 500;
const PLAN_TRUNCATION_MARKER =
  "\n\n... plan truncated — call get_current_plan for full text ...\n\n";

/**
 * Soft-cap plan markdown to avoid duplicating 5–10K chars in every relaunch
 * context fetch. Agents that need the full plan can call `get_current_plan`
 * (or `get_task` with the current task's slug/id).
 */
export function truncatePlanForPrompt(plan: string): string {
  if (plan.length <= PLAN_SOFT_CAP) return plan;
  const head = plan.slice(0, PLAN_HEAD_CHARS);
  const tail = plan.slice(plan.length - PLAN_TAIL_CHARS);
  return `${head}${PLAN_TRUNCATION_MARKER}${tail}`;
}

export const PLAN_TRUNCATION_CONSTANTS = {
  PLAN_SOFT_CAP,
  PLAN_HEAD_CHARS,
  PLAN_TAIL_CHARS,
  PLAN_TRUNCATION_MARKER,
} as const;
